module.exports = __webpack_public_path__ + "img/shoulder-endomorph-male.bf79fdfd.svg";